import { lazy, Suspense, useEffect, useState } from "react";
import { ApiEndpoints } from "../helper/ApiEndpoints";
import AIBlogContent from "./AIBlogContent";
import { useNavigate, useParams } from "react-router-dom";
import ApiRequest from "../helper/ApiRequest";

const AIFaqs = lazy(() => import("./AIFaqs"));
const AIBlogCards = lazy(() => import("./AIBlogCards"));

const AIBlogListEndpoint = ApiEndpoints.AIBlogsFront.AIBlogDetail;
export default function AIBlogDetail() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const { aiblog_slug } = useParams();

  useEffect(() => {
    const fetchData = async (slug) => {
      try {
        const response = await ApiRequest("GET", `${AIBlogListEndpoint}${slug}`);
        const result = response.aiblog;
        if (result) {
          setData(result);
        }
      } catch (error) {
        navigate("/404", { replace: true });
      }
    };

    fetchData(aiblog_slug);
  }, [aiblog_slug]);

  return (
    <>
      <AIBlogContent data={data} />
      <Suspense fallback={null}>
        <AIFaqs faqData={data?.faqs} />
        <AIBlogCards />
      </Suspense>
    </>
  )
}
